import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';
import { ProductsMovements, AdjustmentReason, MovementsState } from './movements.interface';

// Thunks para Usuarios
import * as thunks from './movementsThunks';
import { APIResponse } from '@/types/custom-http';


const initialState: MovementsState = {
  items: [],
  selectedMovement: null,
  motivos: [],
  loading: false,
  error: null,
};



// Slice
const movementsSlice = createSlice({
  name: 'movements',
  initialState,
  reducers: {
    clearMovements: (state) => {
      state.items = [];
    },
    clearSelectedMovement: (state) => {
      state.selectedMovement= null;
    },
    clearReasons: (state) => {
      state.motivos = [];
    },
    clearMovementError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Obtener todos los movimientos de stock
      .addCase(thunks.fetchProductsMovements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchProductsMovements.fulfilled, (state, action: PayloadAction<APIResponse<{page: number; size: number; total: number; totalPages: number; movimientos: ProductsMovements[]}>>) => {
        state.loading = false;
        if(action.payload.data){
          state.items = action.payload.data.movimientos;
        }
      })
      .addCase(thunks.fetchProductsMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Crear un nuevo producto
      .addCase(thunks.createProductMovements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.createProductMovements.fulfilled, (state, action: PayloadAction<APIResponse<ProductsMovements>>) => {
        state.loading = false;
        if(action.payload.data){
          state.items.push(action.payload.data);
        }
      })
      .addCase(thunks.createProductMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Obtener los productos con ubicaciones
      .addCase(thunks.fetchAdjustmentReasons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchAdjustmentReasons.fulfilled, (state, action: PayloadAction<APIResponse<AdjustmentReason[]>>) => {
        state.loading = false;
        if(action.payload.data){
          state.motivos = action.payload.data;
        }
      })
      .addCase(thunks.fetchAdjustmentReasons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })
      
  },
});

// Selectors
export const selectAllMovements = (state: RootState) => state.movements.items;
export const selectSelectedMovement = (state: RootState, id: number) => state.movements.items.find(item => item.id === id);
export const selectReasonsAdjustments = (state: RootState) => state.movements.motivos;
export const selectMovementLoading = (state: RootState) => state.movements.loading;
export const selectMovementError = (state: RootState) => state.movements.error;

// Actions
export const { clearMovements, clearSelectedMovement, clearReasons, clearMovementError} = movementsSlice.actions;

export default movementsSlice.reducer;